const MESSENGER_DICT = {
  0: 'Skype',
  1: 'Viber',
  2: 'WhatsApp',
  3: 'Telegram',
  4: 'Yandex',
};

export const messengerName = (val) => MESSENGER_DICT[val];

const directionNameDict = {
  31: 'incoming',
  32: 'outgoing',
};

export const directionName = (val) => directionNameDict[val];
